import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom'; // For React applications
import { FaChartLine, FaMobileAlt, FaUsers, FaServer } from 'react-icons/fa';
import { Helmet } from 'react-helmet'; // For managing head tags in React
import caseStudies from "./CaseData";

const CaseStudiesPage = () => {

  const getIconComponent = (iconName) => {
    switch(iconName) {
      case 'chart':
        return <FaChartLine className="w-3 h-3 mr-2" />;
      case 'mobile':
        return <FaMobileAlt className="w-3 h-3 mr-2" />;
      case 'users':
        return <FaUsers className="w-3 h-3 mr-2" />;
      case 'server':
        return <FaServer className="w-3 h-3 mr-2" />;
      default:
        return <FaChartLine className="w-3 h-3 mr-2" />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Our Case Studies | Digital Solutions Company</title>
        <meta name="description" content="Explore our successful projects and client transformations" />
        <link rel="canonical" href="https://merndigital.com/case-studies" />
      </Helmet>

      <main className="bg-gray-900 text-gray-100 min-h-screen">
        <section className="py-20 container mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Case Studies</h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Detailed look at how we solve complex business challenges
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {caseStudies.map((study) => (
  <div key={study.id} className="bg-gray-800 rounded-2xl overflow-hidden shadow-lg hover:shadow-blue-500/20 transition-shadow">
    <div className="h-48 overflow-hidden">
      <img
        src={study.coverImage}
        alt={study.title}
        className="w-full h-full object-cover"
      />
    </div>
    <div className="p-6">
      <div className="flex flex-wrap gap-2 mb-3">
        {study.tags.map((tag, index) => (
          <span key={index} className="px-2 py-1 bg-gray-700 text-gray-200 rounded-full text-xs">
            {tag}
          </span>
        ))}
      </div>
      <h2 className="text-xl font-bold mb-2">{study.title}</h2>
      <p className="text-gray-400 mb-4">{study.excerpt}</p>
      <ul className="mb-5 space-y-2 text-sm text-gray-300">
        {study.results.slice(0, 2).map((result, i) => (
          <li key={i} className="flex  items-center">
            {getIconComponent(result.icon)}
            {result.metric}
          </li>
        ))}
      </ul>
      <Link 
        to={`/case-studies/${study.slug}`} 
        className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium text-sm"
      >
        Read full story <FiArrowRight className="ml-2" />
      </Link>
    </div>
  </div>
))}

          </div>
        </section>
      </main>
    </>
  );
};

export default CaseStudiesPage;